import React, {useContext} from 'react';

interface ReactFlowWrapperContextValue {
  reactFlowControlsXPosition: number | null;
}

export const ReactFlowWrapperContext = React.createContext<ReactFlowWrapperContextValue | null>(null);

export default function useReactFlowControlsXPosition(): number | null {
  const context = useContext(ReactFlowWrapperContext);
  if (context == null) {
    throw new Error('useReactFlowControlsXPosition must be used within a ReactFlowWrapper');
  }
  return context.reactFlowControlsXPosition;
}
